/** Helper for converting 1 old address format row to fields and separators object. */
export function parseOldAddressLine(text) {
  const placeholderRegex = /{([^}]*)}/g;
  const fields = [];
  const separators = [];
  let lastIndex = 0;
  const regexResult = [...text.matchAll(placeholderRegex)];
  regexResult.forEach((item, fieldIndex) => {
    if (item[0] && item[1]) {
      fields.push(item[1].toString());
      separators.push(text.slice(lastIndex, item.index));
      lastIndex = item.index + item[0].length;
      if (fieldIndex === regexResult.length - 1) {
        separators.push(text.slice(lastIndex));
      }
    }
  });
  return fields.length ? {
    fields,
    separators
  } : undefined;
}

/**
 * Parses older HTML address format serialized in a string like
 *
 * "{StreetAddress}<br/>C.P. {ZipCode} {Region} {Area} {City}<br/>{Country}"
 *
 * and converts it to the newer API `GlobalCustomersAddressFormatDto` format
 *
 * {
 *   lines: [
 *     { fields: ['StreetAddress'], separators: ['', ''] },
 *     { fields: ['ZipCode', 'Region', 'Area', 'City'], separators: ['C.P. ', ' ', ' ', ' ', ''] },
 *     { fields: ['Country'], separators: ['', ''] },
 *   ],
 *   type: 'MultiLine',
 * }
 *
 * @obsolete Can be dropped once the checkout app is served by ASMS, thus using the API to get configuration.
 */
export function parseOldAddressFormat(addressFormat) {
  const text = addressFormat.replaceAll('"', '').replaceAll('<br />', '<br>').replaceAll('<br/>', '<br>');
  const textLines = text.split('<br>');
  const lines = textLines.map(line => parseOldAddressLine(line)).filter(line => line !== undefined);
  return {
    lines,
    type: 'MultiLine'
  };
}